import { DataParamsApi } from "@impero-com/ui/domain";

import {
    DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM,
    dashboardPendingActivityListDataParamsCodecMap,
} from "./consts";
import { isControlActivityRow } from "./tableUtils";
import { PendingActivityTableRow } from "./types";

export interface PendingActivityTypeFilter {
    includeControlActivities: boolean;
    includeTestingActivities: boolean;
    setIncludeControlActivities: (checked: boolean) => void;
    setIncludeTestingActivities: (checked: boolean) => void;
    /** True when a box is unchecked, so the filter bar counts it as one applied filter. */
    isNonDefault: boolean;
}

export function getPendingActivityTypeFilter(
    dataParams: DataParamsApi<
        typeof dashboardPendingActivityListDataParamsCodecMap
    >,
    controlTestingEnabled: boolean
): PendingActivityTypeFilter {
    // Without Control Testing the boxes are hidden, so a stored unchecked box must not hide rows
    const includeControlActivities =
        !controlTestingEnabled || dataParams.values.includeControlActivities;
    const includeTestingActivities =
        !controlTestingEnabled || dataParams.values.includeTestingActivities;

    return {
        includeControlActivities,
        includeTestingActivities,
        setIncludeControlActivities: (checked) =>
            dataParams.setValue(
                DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_CONTROL_ACTIVITIES,
                checked
            ),
        setIncludeTestingActivities: (checked) =>
            dataParams.setValue(
                DASHBOARD_PENDING_ACTIVITIES_DATA_PARAM.INCLUDE_TESTING_ACTIVITIES,
                checked
            ),
        isNonDefault: !includeControlActivities || !includeTestingActivities,
    };
}

/** Both boxes unchecked gives an empty list. */
export function filterRowsByType(
    rows: PendingActivityTableRow[],
    typeFilter: Pick<
        PendingActivityTypeFilter,
        "includeControlActivities" | "includeTestingActivities"
    >
): PendingActivityTableRow[] {
    const { includeControlActivities, includeTestingActivities } = typeFilter;
    // Keep the same array when nothing is filtered out, so the table's data doesn't change identity
    if (includeControlActivities && includeTestingActivities) {
        return rows;
    }
    return rows.filter((row) =>
        isControlActivityRow(row)
            ? includeControlActivities
            : includeTestingActivities
    );
}
